import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyModule } from 'owa-bundling';

import { TxpCalendarFormWrapperProps } from './components/TxpCalendarFormWrapper';
import { TxpPeekWrapperProps } from './components/TxpPeekWrapper';
import { TxpProps } from './components/Txp';
import { TxpHeaderProps } from './components/TxpHeader';
import { ReadingPaneTxpHeaderProps } from './components/ReadingPaneTxpHeader';

import TailoredActionName from './store/schema/telemetry/TailoredActionName';
import TxpSource from './store/viewSchema/TxpSource';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Txp", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export const Txp = createLazyComponent(lazyModule, m => m.Txp);
export const TxpPeekWrapper = createLazyComponent(lazyModule, m => m.TxpPeekWrapper);
export const TxpCalendarFormWrapper = createLazyComponent(
    lazyModule,
    m => m.TxpCalendarFormWrapper
);
export const UserVoice = createLazyComponent(lazyModule, m => m.UserVoice);
export const TxpHeader = createLazyComponent(lazyModule, m => m.TxpHeader);
export const ReadingPaneTxpHeader = createLazyComponent(lazyModule, m => m.ReadingPaneTxpHeader);

export {
    ReadingPaneTxpHeaderProps,
    TxpProps,
    TxpPeekWrapperProps,
    TxpHeaderProps,
    TxpCalendarFormWrapperProps,
    TxpSource,
    TailoredActionName,
};
